<div class="registration-container">
  @if(registratrationSuccess) {
    <div class="registration-success">
      <img src="assets/imgs/registration-success.svg" alt="registration-success">
      <div class="registration-success-title">You've successfully registered</div>
      @if(isIndustryType) {
        <div class="registration-success-subtitle">Log in and complete your profile</div>
        <button
        class="reset-form-container-button dark-button"
        (click)="goToLogin()"
        >GO TO LOGIN</button>
      } @else {
        <button
        class="reset-form-container-button dark-button"
        (click)="goToDomain()"
        >CHECK YOUR INBOX ON {{emailDomain | uppercase}}</button>
      }
    </div>
  } @else {
    <div class="registration-form">
      <div class="registration-form-title">REGISTER</div>
      <form [formGroup]="form" class="registration-form-container">
        <span class="registration-form-container-label">Profile Picture <span class="required">*</span></span>
        <div class="registration-avatar-upload">
          <div class="registration-avatar-preview">
            <img
              [src]="selectedFilePreview || 'assets/imgs/profile-image.png'"
              alt="profile preview"
            />
          </div>
          <div class="registration-avatar-upload-area">
            <input
              id="avatar-file-input"
              type="file"
              accept="image/svg+xml, image/png, image/jpeg"
              (change)="handleFileSelect($event)"
              hidden
            />
            <label for="avatar-file-input" class="registration-file-input-label">
              <img src="assets/imgs/upload.svg" alt="upload" />
              <span class="registration-file-input-text">Upload photo</span>
            </label>
            <div class="registration-avatar-hint">SVG, PNG, JPG (max. 3MB)</div>
          </div>
        </div>
        @if(fileSubmitAttempted && !selectedFile) {
          <span class="registration-form-container-error">Profile picture is required</span>
        }
        <span class="registration-form-container-label">Full Name <span class="required">*</span></span>
        <input 
        [ngClass]="{'registration-form-container-input__error': form.get('fullName')?.invalid && form.get('fullName')?.touched}"
        class="registration-form-container-input"  formControlName="fullName">
        @if(form.get('fullName')?.invalid && form.get('fullName')?.touched) {
          <span class="registration-form-container-error">Full Name is required</span>
        }
        <span class="registration-form-container-label">Email <span class="required">*</span></span>
        <input
        [ngClass]="{'registration-form-container-input__error': form.get('email')?.invalid && form.get('email')?.touched}"
        class="registration-form-container-input"  formControlName="email">
        @if(form.get('email')?.invalid && form.get('email')?.touched) {
          <span class="registration-form-container-error">Email is required</span>
        }
        <span class="registration-form-container-label">Password <span class="required">*</span></span>
        <div class="password-input-wrapper">
          <input
            [ngClass]="{'registration-form-container-input__error': form.get('password')?.invalid && form.get('password')?.touched}"
            class="registration-form-container-input"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password">
          <img
            [src]="'assets/imgs/password-eye.svg'"
            class="password-toggle"
            [class.visible]="showPassword"
            (click)="togglePasswordVisibility('password')"
            alt="toggle password visibility">
        </div>

        @if(form.get('password')?.touched && form.get('password')?.invalid) {
          <div class="registration-form-container-password-requirements">
            @if(form.get('password')?.hasError('required')) {
              <span class="registration-form-container-error">Password is required</span>
            }
            @if(form.get('password')?.hasError('minLength')) {
              <span class="registration-form-container-error">At least 8 characters</span>
            }
            @if(form.get('password')?.hasError('noUppercase')) {
              <span class="registration-form-container-error">At least one uppercase letter</span>
            }
            @if(form.get('password')?.hasError('noLowercase')) {
              <span class="registration-form-container-error">At least one lowercase letter</span>
            }
            @if(form.get('password')?.hasError('noNumber')) {
              <span class="registration-form-container-error">At least one number</span>
            }
            @if(form.get('password')?.hasError('noSpecial')) {
              <span class="registration-form-container-error">At least one special character</span>
            }
          </div>
        }

        <span class="registration-form-container-label">Confirm Password <span class="required">*</span></span>
        <div class="password-input-wrapper">
          <input
            [ngClass]="{'registration-form-container-input__error': form.get('confirmPassword')?.invalid && form.get('confirmPassword')?.touched}"
            class="registration-form-container-input"
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmPassword">
          <img
            [src]="'assets/imgs/password-eye.svg'"
            class="password-toggle"
            [class.visible]="showConfirmPassword"
            (click)="togglePasswordVisibility('confirmPassword')"
            alt="toggle password visibility">
        </div>

        @if(form.get('confirmPassword')?.touched) {
          @if(form.get('confirmPassword')?.hasError('required')) {
            <span class="registration-form-container-error">Confirm password is required</span>
          }
          @if(form.get('confirmPassword')?.hasError('passwordMismatch')) {
            <span class="registration-form-container-error">Passwords do not match</span>
          }
        }
       
        <span class="registration-form-container-label">Phone <span class="required">*</span></span>

        <wire-phone-input
        formGroupName="phone"
        [initialValue]="initialValue"
        (phoneNumberChange)="handlePhoneNumberChange($event)"
        (countryChange)="handleCountryChange($event)"
      ></wire-phone-input>
      @if(form.get('phone.mobile')?.invalid && form.get('phone.mobile')?.touched) {
        <span class="registration-form-container-error">Phone number is required</span>
      }
      
        <div class="registration-form-container-button-container">
          <button
          [ngClass]="{'disabled': form.invalid || !selectedFile}"
          (click)="register()"
          class="registration-form-container-button red-button"
          [disabled]="form.invalid || !selectedFile"
          >NEXT</button>
          <button 
          class="registration-form-container-button dark-button" 
          (click)="$event.preventDefault()"
          [routerLink]="['/login']"  
          >LOGIN</button>
        </div>
      </form>
    </div>
  }
 
</div>